import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, ...props }, ref) => {
        return (
            <textarea
                className={cn(
                    "peer flex min-h-[10rem] border border-stroke hover:border-fade w-full rounded-[24px] p-3 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand [.invalid_&]:ring-1 [.invalid_&]:ring-red-500 disabled:cursor-not-allowed disabled:opacity-50 bg-transparent",
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);

Textarea.displayName = "Textarea";

export { Textarea };
